<ng-container ntapDynamicFormProvider>
    <ntap-view-window target="detail" [contentTemplate]="viewWindowContent">
        <ng-template #viewWindowContent let-defaultTemplate>
            <ntap-prime-popupview appendTo="body">
                <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
            </ntap-prime-popupview>
        </ng-template>
    </ntap-view-window>
    <div class="flex flex-nowrap">
        <ng-container ntapNewListItemProvider>
            <ntap-prime-action-open-view [inputParam]="newEntryTemplateActionParams"
                class="mr-1"></ntap-prime-action-open-view>
        </ng-container>
        <ng-container *ngIf="entryTemplateItem$ | async as entryTemplate">
            <ng-container appFastDataEntryViewItemProvider [item]="entryTemplate">
                <app-edit-obrazac-upisa-action [inputParam]="editEntryTemplateActionParams$ | async"
                        class="mr-1"></app-edit-obrazac-upisa-action>
            </ng-container>
            <ng-container ntapViewItemProvider [item]="entryTemplate" #deleteItemProvider>
                <app-delete-obrazac-upisa-action [inputParam]="deleteEntryTemplateActionParams$ | async"></app-delete-obrazac-upisa-action>
            </ng-container>
        </ng-container>
    </div>
</ng-container>